/** RFC 4122 UUID v1–v5 (case-insensitive). Client-side route guard only. */
const TEMPLATE_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isTemplateId(value: string): boolean {
  return TEMPLATE_ID_RE.test(value);
}
